import type { Typographies } from "@superblocksteam/shared";
export const DEFAULT_CHECKBOX_WIDGET_TEXT_STYLE_VARIANT: keyof Typographies =
  "inputLabel";
